import store from 'utils/store/withMiddleware'
import forEach from 'utils/DOM/forEach'

export const customViews = (
  agents: number[],
  classNames: string[],
  target?: StringOrNodeSelector
) => {
  const finalTarget = target || document.body

  const state = store.getState()
  if (!agents.includes(state.hcStorage.agent_id)) return

  forEach(finalTarget, node => node.classList.add(...classNames))
}
